<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="7">
        <v-card class="elevation-12">
             <v-row >
               <v-col cols="12" sm="12" md="12" class="rmpadding">
                 <v-toolbar-title align="center" class="clearfix" justify="center"><h4> Change Password </h4></v-toolbar-title>
               </v-col>  
            </v-row>
        
         <div v-if="getstatus === 'fail'" class="alert alert-danger" role="alert">{{message}}</div>
          <div v-else-if="getstatus === 'success'" class="alert alert-success" >
            {{message}}
          </div>  
          <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-card-text>
            <v-row>
                <v-col cols="12">
                
                   <v-text-field
            v-model="oldpassword"
            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="oldpasswordRule"
            :type="show3 ? 'text' : 'password'"
            name="input-10-1"
            label="Old Password"
            hint="At least 6 characters"
            autocomplete="off"
            @click:append="show3 = !show3"
          ></v-text-field>
                </v-col>
             </v-row>    
            <v-row>
                <v-col cols="12">
                
                   <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRule"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="New Password"
            hint="At least 6 characters"
            counter
            autocomplete="off"
            @click:append="show1 = !show1"
          ></v-text-field>
                </v-col>
             </v-row>
             <v-row>
                <v-col cols="12">
                <v-text-field
                        v-model="confirmpassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="confirmpasswordRule"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        hint="At least 6 characters"
                        counter
                        autocomplete="off"
                        @click:append="show2 = !show2"
          ></v-text-field>   </v-col>
              </v-row> 
            
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Update</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChangePassword",
  data() {
    return {
      message:"",
      oldpassword: "",
      password: "",
      confirmpassword:"", 
       passwordRule: [
        v => v.length >= 6 || "Password must be at least 6 characters"
      ],
       oldpasswordRule: [
        v => v.length >= 6 || "Old Password must be at least 6 characters"
      ],
      confirmpasswordRule: [
        v => v.length >= 6 || "Confirm Password must be at least 6 characters",
         v =>
          v === this.password || 'The password confirmation does not match.',
      ],
       show1: false,
       show2 : false,
       show3 : false,
       getstatus:"" ,
        error:false,
      errorText:"",
    };
  },
  computed:{
          baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }, 
             name() {
                return this.$store.getters.name;
              },
     },
  mounted(){
      this.getUserData();
  },
  methods: {
    getUserData() {
     
       this.$store.dispatch("retrieveUserDetails").then(() => {
          //   this.email  = this.$store.getters.email;
         });

    },
    validate() {
      if (this.$refs.form.validate()) {
        this.updatepassword();
      }
    },
    
    updatepassword() {

      let formData = new FormData();
      
        formData.append('current_password', this.oldpassword);
        formData.append('new_password', this.password);
        const damntoken =  localStorage.getItem('damn_token');
        formData.append('damnntoken', damntoken);
        
     
      this.$store
        .dispatch("changepassword", formData)
        .then(response => {
          console.log(response);
         // this.$router.push({ name: "login" });
         //   this.getstatus =  localStorage.getItem('response_status');// this.$store.getters.geteditProfileMessage.status;
         //   this.message =  localStorage.getItem('response_message');// this.$store.getters.geteditProfileMessage.message;
           this.getstatus = "success";
           this.message = "Update Successfully";
             this.oldpassword = "";
             this.password ="";
             this.confirmpassword = ""; 
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("logging error from login");
          console.log(error);
          
           this.getstatus = "fail";
           this.message = error.response.data.message;
          //alert(error.response.data.message);
        });
    },
  }
};
</script>

<style scoped>
.row {
  margin-left: 0px;
}
.rmpadding{padding:0px !important;}
.clearfix{clear: both;margin-bottom:15px;}
.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    margin-top:28px;
}
.lf-mr{margin-left:10%;}
</style>